<template lang="pug">
// Example Usage:
// ButtonExit(@click='onCancelClicked') Cancel
v-btn(variant='outlined')
    slot
</template>

<script setup lang="ts"></script>
